<form [formGroup]="formGroup">
	@if (isLoading || isLoadingBaseData) {
		<mat-spinner mode="indeterminate" diameter="30" class="mx-a"></mat-spinner>
	} @else {
		<app-card [inCardTitle]="vehicleGroup.name"
				  icon="arrow_back"
				  [iconDisabled]="!vehicleGroup.id"
				  (iconClicked)="navigateBack()">
			<div *appCardContent class="mt-16">
				<app-row-with-toggle primaryText="Require trip inspections"
									 formControlName="useDvir">
				</app-row-with-toggle>
				<div [style.display]="formGroup.controls['useDvir'].value ? 'block' : 'none'" class="indent mb-16">
					<div>
						<app-row-with-select
								primaryText="Pre-trip inspection form"
								[list]="allInspectionForms"
								listLabel="name"
								nullLabel="None"
								listId="id"
								formControlName="preTripFormId">
						</app-row-with-select>
					</div>

					<div>
						<app-row-with-select
								primaryText="Post-trip inspection form"
								[list]="allInspectionForms"
								listLabel="name"
								nullLabel="None"
								listId="id"
								formControlName="postTripFormId">
						</app-row-with-select>
					</div>
					@if (formGroup.hasError('dvirMissing')) {
						<mat-error>Select one of the pre-trip or post-trip inspection form</mat-error>
					}
				</div>
				<mat-divider></mat-divider>

				<app-row-with-toggle
						primaryText="Allow drivers to self assign routes"
						formControlName="allowRouteSelfAssign"
						[children]="allAllowedRouteConfigs"
						[checkedChildren]="formGroup.controls['allowedRouteConfigIds'].value"
						(checkedChildrenChange)="this.formGroup.controls['allowedRouteConfigIds'].setValue($event)">
				</app-row-with-toggle>
				@if (formGroup.hasError('routesMissing')) {
					<mat-error class="indent mb-8">Select at least one route set</mat-error>
				}

				<mat-divider></mat-divider>

				<app-row-with-toggle
						primaryText="Allow drivers to report observations"
						formControlName="allowReportObservations"
						[children]="allObservationTypeGroups"
						[checkedChildren]="formGroup.controls['observationTypeGroupIds'].value"
						(checkedChildrenChange)="this.formGroup.controls['observationTypeGroupIds'].setValue($event)">
				</app-row-with-toggle>
				@if (formGroup.hasError('observationTypeMissing')) {
					<mat-error class="indent mb-8">Select at least one observation type</mat-error>
				}

				<mat-divider></mat-divider>

				<app-row-with-toggle primaryText="&quot;Show Other Vehicles&quot; on by default"
									 formControlName="showVehicles">

				</app-row-with-toggle>

				<mat-divider></mat-divider>

        <div class="flex-row field-row label-width-60 align-items-center justify-content-space-between mh-48">
          <div class="field-row-title">
            Default Vehicle Location History Theme
          </div>
          <div class="field-row-element">
            <mat-form-field subscriptSizing="dynamic">
              <mat-select formControlName="defaultHistoryTheme" placeholder="GPS Tracks">
                <mat-option [value]="null">GPS Tracks</mat-option>
                <mat-option [value]="StatusLayerType.CURRENCY">Time Map</mat-option>
                <mat-option [value]="StatusLayerType.COVERAGE">Pass Count Map</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <mat-divider></mat-divider>

				<app-row-with-toggle
          primaryText="&quot;Show Other Vehicle History&quot; on by default"
          formControlName="showVehicleHistory"
          [children]="allVehicleGroups"
          [checkedChildren]="formGroup.controls['showTracksForVehicleGroupIds'].value"
          (checkedChildrenChange)="formGroup.controls['showTracksForVehicleGroupIds'].setValue($event)"
          (checkedChange)="onVehicleHistoryChange()">
				</app-row-with-toggle>
        @if (formGroup.hasError('vehicleGroupMissing')) {
          <mat-error class="indent mb-8">Select at least one vehicle group</mat-error>
        }

				<mat-divider></mat-divider>

				<app-row-with-toggle
          primaryText="&quot;Show Other Vehicle Observations&quot; on by default"
          formControlName="showVehicleObservations"
          [children]="allObservationTypeGroups"
          [checkedChildren]="formGroup.controls['showObservationsByObservationGroupIds'].value"
          (checkedChildrenChange)="formGroup.controls['showObservationsByObservationGroupIds'].setValue($event)"
          (checkedChange)="onVehicleObservationsChange()">
				</app-row-with-toggle>
        @if (formGroup.hasError('observationTypeOnShowObsMissing')) {
          <mat-error class="indent mb-8">Select at least one observation type</mat-error>
        }

        <mat-divider></mat-divider>

        <app-row-with-toggle
          primaryText="Enable Custom Map Layers on Shift Start"
          formControlName="enableCustomMapLayers"
          [children]="allCustomMapLayers"
          [checkedChildren]="formGroup.controls['enabledCustomMapLayerIds'].value"
          (checkedChildrenChange)="this.formGroup.controls['enabledCustomMapLayerIds'].setValue($event)">
        </app-row-with-toggle>
        @if (formGroup.hasError('noCustomMapLayerEnabled')) {
          <mat-error class="indent mb-8">Select at least one custom map layer</mat-error>
        }

        <mat-divider></mat-divider>

        <div class="flex-row field-row label-width-60 align-items-center justify-content-space-between mh-48">
          <div class="field-row-title">
            Default Basemap
            <div>Basemap used as default on each shift</div>
          </div>
          <div class="field-row-element">
            <mat-form-field subscriptSizing="dynamic">
              <mat-select formControlName="defaultBaseMap" placeholder="Winter">
                <mat-option [value]="null">Winter</mat-option>
                <mat-option [value]="BaseMapType.DARK">Dark</mat-option>
                <mat-option [value]="BaseMapType.IMAGERY">Imagery</mat-option>
                <mat-option [value]="BaseMapType.OUTDOORS">Outdoors</mat-option>
                @for (customMapLayer of allCustomBaseLayers; track customMapLayer.id) {
                  <mat-option [value]="String(customMapLayer.id)">{{ customMapLayer.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
			</div>
		</app-card>
	}
</form>
